module.exports = __webpack_public_path__ + "static/img/img.56489b12.jpg";